module.exports = __webpack_public_path__ + "static/img/SAM-GILBEY.3bbb6f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-GILBEY.jpg
// module id = 8g4I
// module chunks = 0